module.exports = __webpack_public_path__ + "static/img/exhibitor_normal_en.9360b8d4.png";